var _ConsoleLogger_consoleLoggerConfig;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { LogLevel } from './_types';
import Logger from './Logger';
import { NotImplementedException } from '../Exceptions';
const defaultConfig = {
    loggingVerbosity: LogLevel.Info,
    useTraceMethodForTraceLogLevel: false
};
export default class ConsoleLogger extends Logger {
    constructor(console, config = defaultConfig) {
        super(config);
        _ConsoleLogger_consoleLoggerConfig.set(this, void 0);
        __classPrivateFieldSet(this, _ConsoleLogger_consoleLoggerConfig, config, "f");
        this._debugMethod = console.log.bind(console);
        this._defaultMethod = console.log.bind(console);
        this._errorMethod = (console.error || console.log).bind(console);
        this._infoMethod = (console.info || console.log).bind(console);
        // sometimes the trace method is wayyyy too verbose....
        this._traceMethod = __classPrivateFieldGet(this, _ConsoleLogger_consoleLoggerConfig, "f").useTraceMethodForTraceLogLevel
            ? (console.trace || console.log).bind(console)
            : this._defaultMethod;
        this._warnMethod = (console.warn || console.log).bind(console);
    }
    _errorMethod() {
        throw new NotImplementedException();
    }
    _warnMethod() {
        throw new NotImplementedException();
    }
    _infoMethod() {
        throw new NotImplementedException();
    }
    _traceMethod() {
        throw new NotImplementedException();
    }
    _debugMethod() {
        throw new NotImplementedException();
    }
    _defaultMethod() {
        throw new NotImplementedException();
    }
}
_ConsoleLogger_consoleLoggerConfig = new WeakMap();
